import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IAddEditMarketmakingTask,
  IMarketmakingTaskTableReport,
  MarketmakingTableTabs,
} from "../../Interfaces/marketmaking";

interface IMarketmakingSlice {
  addTaskFormValues: IAddEditMarketmakingTask | null;
  tasksTableFetchDataFlag: boolean;
  isEdit: boolean;
  clickedTaskTableRowValues: IMarketmakingTaskTableReport | null;
  tabIndex: MarketmakingTableTabs;
}

const initialState: IMarketmakingSlice = {
  addTaskFormValues: {} as IAddEditMarketmakingTask,
  tasksTableFetchDataFlag: false,
  isEdit: false,
  clickedTaskTableRowValues: null,
  tabIndex: MarketmakingTableTabs.OrderTable,
};

const MarketmakingSlice = createSlice({
  name: "marketmaking",
  initialState,
  reducers: {
    setMarketmakingAddTaskFormValues: (
      store,
      action: PayloadAction<IAddEditMarketmakingTask>
    ) => {
      store.addTaskFormValues = action.payload;
    },
    onMarketmakingTaskFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2?: any;
      }>
    ) => {
      if (action.payload.name2)
        store.addTaskFormValues = {
          ...store.addTaskFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as IAddEditMarketmakingTask;
      else
        store.addTaskFormValues = {
          ...store.addTaskFormValues,
          [action.payload.name]: action.payload.value,
        } as IAddEditMarketmakingTask;
    },
    setMarketmakingTaskTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      if (store.tasksTableFetchDataFlag !== action.payload)
        store.tasksTableFetchDataFlag = action.payload;
    },
    setMarketmakingTaskTableClickedRowValues: (
      store,
      action: PayloadAction<IMarketmakingTaskTableReport | null>
    ) => {
      store.clickedTaskTableRowValues = action.payload;
    },
    setMarketmakingTabIndex: (
      store,
      action: PayloadAction<MarketmakingTableTabs>
    ) => {
      store.tabIndex = action.payload;
    },
    setMarketmakingIsEditFlag: (store, action: PayloadAction<boolean>) => {
      store.isEdit = action.payload;
    },
  },
});

export const {
  setMarketmakingAddTaskFormValues,
  setMarketmakingTaskTableFetchDataFlag,
  onMarketmakingTaskFormValuesChange,
  setMarketmakingTaskTableClickedRowValues,
  setMarketmakingTabIndex,
  setMarketmakingIsEditFlag,
} = MarketmakingSlice.actions;
export default MarketmakingSlice.reducer;
